import script from "./HomeView.vue?vue&type=script&setup=%7Bname%3A%20'home'%7D&lang=ts"
export * from "./HomeView.vue?vue&type=script&setup=%7Bname%3A%20'home'%7D&lang=ts"

import "./HomeView.vue?vue&type=style&index=0&id=46bcc392&lang=less&scoped=true"

import exportComponent from "/app/10119217139/workspace/IBU-IFSP_PUBLIC/IBU-IFSP-OPENAPI/OPENAPI_WEB_PORTAL_BUILD_GKE_DIRECT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46bcc392"]])

export default __exports__